export const SupplierProductsSteps = [
    {
        target: '.MuiDataGrid-columnHeaders ',
        placementBeacon: "top",
        disableScrolling: true,
        content: 'The Columns for a Table are displayed here. Hover over a column header to display the column menu buttons.',
    },
    {
        target: '.column-header-demo',
        placementBeacon: "top",
        content: 'Each Column can be clicked to sort by that column and have a column menu to allow filtering and more',
    },
    {
        target: '#demo-column-menu-button',
        placementBeacon: "top",
        spotlightClicks: true,
        content: 'By accessing the Column Menu, you can hide and display different columns. Click the button to open the menu.',
    },
    {
        target: '.MuiDataGrid-menuList',
        disableBeacon: true,
        content: 'Here you find the filter options, pinning, grouping and managing column visibility.'    },

    // {
    //     target: ".TestTable .MuiMenuItem-root:last-child",
    //     disableBeacon: true,
    //     content: "To manage all Columns visibility, click on the 'Manage Columns' button."
    // },
]